import { render } from "./FormGoals.vue?vue&type=template&id=0b2df146&scoped=true"
import script from "./FormGoals.vue?vue&type=script&lang=js"
export * from "./FormGoals.vue?vue&type=script&lang=js"

import "./FormGoals.vue?vue&type=style&index=0&id=0b2df146&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2df146"]])

export default __exports__